import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import WholesalePage from './pages/Wholesale.js';
import ContactPage from './pages/Contact.js';
import AboutPage from './pages/About.js';
import NotFoundPage from './pages/NotFound.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/wholesale" element={<WholesalePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
